<div class="MapOverlay">
    <slot/>
</div>
